import { createSlice } from '@reduxjs/toolkit'
import { fetchRecentPosters } from '../fetch/documents';
const recentPostersSlice = createSlice({
  name: 'recentPosters',
  initialState: {
    isLoading: false,
    value: [],
    isError: false
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRecentPosters.pending, (state, action) => {
      state.isLoading = true;
    })
    builder.addCase(fetchRecentPosters.fulfilled, (state, action) => {
      state.isLoading = false;
      let data = action.payload.items;
      if (data && data.constructor === Array){
        state.value = data;
      }
    })
    builder.addCase(fetchRecentPosters.rejected, (state, action) => {
      state.isError = true;
    })
  },
  reducers: {


    // incremented: state => {
    //   // Redux Toolkit allows us to write "mutating" logic in reducers. It
    //   // doesn't actually mutate the state because it uses the Immer library,
    //   // which detects changes to a "draft state" and produces a brand new
    //   // immutable state based off those changes
    //   state.value += 1
    // },
    // decremented: state => {
    //   state.value -= 1
    // },
    // setFamily: (state, action) => {
    //   state.value = action.list;
    // },
  }
})
export const selectRecentPosters = (state) => state.recentPosters.value
export const selectLoadingRecentPosters = (state) => state.recentPosters.isLoading
//export const selectPageRecentPosters = (state) => state.recentPosters.page;

export const {} = recentPostersSlice.actions

export default recentPostersSlice.reducer

